module.exports = __webpack_public_path__ + "static/img/SmileAnimation_mango.31a540e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_mango.gif
// module id = UR+4
// module chunks = 0